import HeroSection from "./components/HeroSection";
import LatestReviews from "./components/LatestReviews";
import RealReviews from "./components/RealReviews";
import PopularStores from "./components/PopularStores";
import Top10Guides from "./components/Top10Guides";
import MysteryShoppers from "./components/MysteryShoppers";
import ExploreMore from "./components/ExploreMore";
import SEO from "@/components/SEO";
import { canonical, graphSchema, organizationSchema, websiteSchema } from "@/utils/seo";

export default function Home({ initialData }: { initialData?: Record<string, unknown> }) {
  const title = "美好時光指南 GoldenTimeGuides - 美業探店懶人包與真實評比";
  const description = "美好時光指南透過神秘客實地走訪，為你評比全台最優質的美業店家，從按摩、SPA、美甲到美髮，幫你找到不踩雷的美好體驗。";

  return (
    <div className="min-h-screen">
      <SEO
        meta={{
          title,
          description,
          canonical: canonical("/"),
          keywords: ["美業探店", "SPA評比", "按摩推薦", "美甲懶人包", "美好時光指南", "GoldenTimeGuides"],
          ogType: "website",
          structuredData: graphSchema([
            websiteSchema(),
            organizationSchema(
              "https://readdy.ai/api/search-image?query=A%20bold%20geometric%20compass%20needle%20logo%20icon%20for%20a%20beauty%20discovery%20guide%20brand%20GoldenTimeGuides%2C%20featuring%20a%20sharp%20symmetrical%20directional%20pointer%20pointing%20northeast%20inside%20a%20perfect%20circular%20ring%2C%20with%20a%20small%20decorative%20star%20at%20the%20center%20pivot%20point%2C%20rendered%20in%20vivid%20burnt%20orange%20and%20warm%20ivory%20white%2C%20ultra-clean%20flat%20vector%20graphic%20with%20thick%20confident%20lines%2C%20absolutely%20no%20clock%20elements%2C%20no%20text%2C%20centered%20on%20a%20solid%20pure%20white%20background%2C%20modern%20app%20icon%20style%2C%20crisp%20edges%20and%20minimalist%20design%20for%20website%20branding&width=1200&height=1200&seq=gtg-logo-schema-v1&orientation=squarish"
            ),
          ]),
        }}
      />
      <HeroSection />
      <LatestReviews />
      <RealReviews />
      <PopularStores />
      <Top10Guides />
      <MysteryShoppers />
      <ExploreMore />
    </div>
  );
}